// This file is auto-generated by @hey-api/openapi-ts

import {
	type Client,
	formDataBodySerializer,
	type Options as Options2,
	type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
	ActivateEmergencyCallData,
	ActivateEmergencyCallErrors,
	ActivateEmergencyCallResponses,
	AddPassengerDetailsData,
	AddPassengerDetailsErrors,
	AddPassengerDetailsResponses,
	CalculatePriceData,
	CalculatePriceErrors,
	CalculatePriceResponses,
	CancelCancellationData,
	CancelCancellationErrors,
	CancelCancellationResponses,
	CanDeleteAccountData,
	CanDeleteAccountErrors,
	CanDeleteAccountResponses,
	CanDeleteDefaultPaymentMethodData,
	CanDeleteDefaultPaymentMethodErrors,
	CanDeleteDefaultPaymentMethodResponses,
	ChangeEmailAddressData,
	ChangeEmailAddressErrors,
	ChangeEmailAddressResponses,
	CheckInPassengerData,
	CheckInPassengerErrors,
	CheckInPassengerResponses,
	CheckInPassengerV2Data,
	CheckInPassengerV2Errors,
	CheckInPassengerV2Responses,
	CheckVehicleData,
	CheckVehicleErrors,
	CheckVehicleResponses,
	CreatePassengerData,
	CreatePassengerErrors,
	CreatePassengerResponses,
	CreateSepaPaymentMethodData,
	CreateSepaPaymentMethodErrors,
	CreateSepaPaymentMethodResponses,
	CreateSubscriptionData,
	CreateSubscriptionErrors,
	CreateSubscriptionResponses,
	DeactivateEmergencyCallData,
	DeactivateEmergencyCallErrors,
	DeactivateEmergencyCallResponses,
	DeleteCapacityCheckData,
	DeleteCapacityCheckErrors,
	DeleteCapacityCheckResponses,
	DeleteDefaultPaymentMethodData,
	DeleteDefaultPaymentMethodErrors,
	DeleteDefaultPaymentMethodResponses,
	DeletePassengerData,
	DeletePassengerErrors,
	DeletePassengerResponses,
	DeleteSearchData,
	DeleteSearchErrors,
	DeleteSearchResponses,
	DeleteTokenData,
	DeleteTokenErrors,
	DeleteTokenResponses,
	GetAccountsData,
	GetAccountsErrors,
	GetAccountsResponses,
	GetActiveVouchersData,
	GetActiveVouchersErrors,
	GetActiveVouchersResponses,
	GetAppleWalletPassData,
	GetAppleWalletPassErrors,
	GetAppleWalletPassResponses,
	GetAvailableInvoicesData,
	GetAvailableInvoicesErrors,
	GetAvailableInvoicesResponses,
	GetBookingLegsData,
	GetBookingLegsErrors,
	GetBookingLegsResponses,
	GetBookingsData,
	GetBookingsErrors,
	GetBookingsResponses,
	GetCapacityCheckData,
	GetCapacityCheckErrors,
	GetCapacityCheckResponses,
	GetCapacityCheckV2Data,
	GetCapacityCheckV2Errors,
	GetCapacityCheckV2Responses,
	GetCheaperTripsData,
	GetCheaperTripsErrors,
	GetCheaperTripsResponses,
	GetCurrentScheduleData,
	GetCurrentScheduleErrors,
	GetCurrentScheduleResponses,
	GetData,
	GetDefaultPaymentMethodData,
	GetDefaultPaymentMethodErrors,
	GetDefaultPaymentMethodResponses,
	GetDigitalBonusData,
	GetDigitalBonusErrors,
	GetDigitalBonusResponses,
	GetDriverAndCarDetailsData,
	GetDriverAndCarDetailsErrors,
	GetDriverAndCarDetailsResponses,
	GetDriverData,
	GetDriverErrors,
	GetDriverLicenceFileData,
	GetDriverLicenceFileErrors,
	GetDriverLicenceFileResponses,
	GetDriverLocationData,
	GetDriverLocationErrors,
	GetDriverLocationResponses,
	GetDriverMapsData,
	GetDriverMapsErrors,
	GetDriverMapsResponses,
	GetDriverResponses,
	GetDriversData,
	GetDriversErrors,
	GetDriversResponses,
	GetEmailStatusData,
	GetEmailStatusErrors,
	GetEmailStatusResponses,
	GetEmergencyCallData,
	GetEmergencyCallErrors,
	GetEmergencyCallResponses,
	GetErrors,
	GetFeatureFlagV2Data,
	GetFeatureFlagV2Errors,
	GetFeatureFlagV2Responses,
	GetFeedbacksByBookingData,
	GetFeedbacksByBookingErrors,
	GetFeedbacksByBookingLegData,
	GetFeedbacksByBookingLegErrors,
	GetFeedbacksByBookingLegResponses,
	GetFeedbacksByBookingResponses,
	GetFeedbacksByDriverData,
	GetFeedbacksByDriverErrors,
	GetFeedbacksByDriverResponses,
	GetFeedbacksByUserData,
	GetFeedbacksByUserErrors,
	GetFeedbacksByUserResponses,
	GetFeedbacksTableData,
	GetFeedbacksTableErrors,
	GetFeedbacksTableResponses,
	GetGoogleWalletData,
	GetGoogleWalletErrors,
	GetGoogleWalletResponses,
	GetLbodtFlexDistributorInfoBySearchIdData,
	GetLbodtFlexDistributorInfoBySearchIdErrors,
	GetLbodtFlexDistributorInfoBySearchIdResponses,
	GetNewIntentData,
	GetNewIntentErrors,
	GetNewIntentResponses,
	GetPlanData,
	GetPlanErrors,
	GetPlanResponses,
	GetProdtDistributorInfoBySearchIdData,
	GetProdtDistributorInfoBySearchIdErrors,
	GetProdtDistributorInfoBySearchIdResponses,
	GetPublicTransportInfoByDistIdData,
	GetPublicTransportInfoByDistIdErrors,
	GetPublicTransportInfoByDistIdResponses,
	GetPublicTransportInfoByLegIdData,
	GetPublicTransportInfoByLegIdErrors,
	GetPublicTransportInfoByLegIdResponses,
	GetPublicTransportInfoData,
	GetPublicTransportInfoErrors,
	GetPublicTransportInfoResponses,
	GetResponses,
	GetScheduleData,
	GetScheduleErrors,
	GetScheduleResponses,
	GetSearchData,
	GetSearchErrors,
	GetSearchResponses,
	GetSubscriptionsData,
	GetSubscriptionsErrors,
	GetSubscriptionsResponses,
	GetSyncBookingsData,
	GetSyncBookingsErrors,
	GetSyncBookingsResponses,
	GetTicketsData,
	GetTicketsErrors,
	GetTicketsResponses,
	GiveFeedbackForJourneyData,
	GiveFeedbackForJourneyErrors,
	GiveFeedbackForJourneyResponses,
	HandleDriverLicenceUploadData,
	HandleDriverLicenceUploadErrors,
	HandleDriverLicenceUploadResponses,
	HasVoucherRemeededData,
	HasVoucherRemeededErrors,
	HasVoucherRemeededResponses,
	HereApiCallData,
	HereApiCallErrors,
	HereApiCallResponses,
	LookupApiCallData,
	LookupApiCallErrors,
	LookupApiCallResponses,
	PatchCapacityCheck1Data,
	PatchCapacityCheck1Errors,
	PatchCapacityCheck1Responses,
	PatchCapacityCheckData,
	PatchCapacityCheckErrors,
	PatchCapacityCheckResponses,
	PatchSearch1Data,
	PatchSearch1Errors,
	PatchSearch1Responses,
	PatchSearchData,
	PatchSearchErrors,
	PatchSearchResponses,
	PostApiCommandByCmdData,
	PostApiCommandByCmdErrors,
	PostApiCommandByCmdResponses,
	PostCapacityCheckData,
	PostCapacityCheckErrors,
	PostCapacityCheckResponses,
	PostCapacityCheckV2Data,
	PostCapacityCheckV2Errors,
	PostCapacityCheckV2Responses,
	PostSearchData,
	PostSearchErrors,
	PostSearchResponses,
	RedeemVoucherData,
	RedeemVoucherErrors,
	RedeemVoucherResponses,
	RegenerateTicketData,
	RegenerateTicketErrors,
	RegenerateTicketResponses,
	RemoveBookingData,
	RemoveBookingErrors,
	RemoveBookingResponses,
	RemoveVoucherData,
	RemoveVoucherErrors,
	RemoveVoucherResponses,
	RunSchedulerData,
	RunSchedulerErrors,
	RunSchedulerResponses,
	RunSchedulersNearFutureData,
	RunSchedulersNearFutureErrors,
	RunSchedulersNearFutureResponses,
	SendInvoiceEmailForBookingData,
	SendInvoiceEmailForBookingErrors,
	SendInvoiceEmailForBookingResponses,
	SendInvoiceEmailForGermanyTicketData,
	SendInvoiceEmailForGermanyTicketErrors,
	SendInvoiceEmailForGermanyTicketResponses,
	SendPushNotificationData,
	SendPushNotificationErrors,
	SendPushNotificationResponses,
	SetAlternateInvoiceAddressData,
	SetAlternateInvoiceAddressErrors,
	SetAlternateInvoiceAddressResponses,
	SetDefaultPaymentMethodData,
	SetDefaultPaymentMethodErrors,
	SetDefaultPaymentMethodResponses,
	SetLanguageData,
	SetLanguageErrors,
	SetLanguageResponses,
	SpenditTokenData,
	SpenditTokenErrors,
	SpenditTokenResponses,
	StartVehicleCheckData,
	StartVehicleCheckErrors,
	StartVehicleCheckResponses,
	StoreDriverLocationData,
	StoreDriverLocationErrors,
	StoreDriverLocationResponses,
	ToggleArchivation2Data,
	ToggleArchivation2Errors,
	ToggleArchivation2Responses,
	ValidateEmailAddressData,
	ValidateEmailAddressErrors,
	ValidateEmailAddressResponses,
	ValidateVoucherData,
	ValidateVoucherErrors,
	ValidateVoucherResponses,
	WhoAmIData,
	WhoAmIErrors,
	WhoAmIResponses,
} from './types.gen';

export type Options<
	TData extends TDataShape = TDataShape,
	ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

/**
 * process command given by path command name
 * process command by name, command details/payload is given by request body
 */
export const postApiCommandByCmdApi = <ThrowOnError extends boolean = true>(
	options: Options<PostApiCommandByCmdData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		PostApiCommandByCmdResponses,
		PostApiCommandByCmdErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/command/{cmd}',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getLbodtFlexDistributorInfoBySearchIdApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<GetLbodtFlexDistributorInfoBySearchIdData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetLbodtFlexDistributorInfoBySearchIdResponses,
		GetLbodtFlexDistributorInfoBySearchIdErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/distributor/info/lbodt-flex/search-id/{searchId}',
		...options,
	});
};

export const getProdtDistributorInfoBySearchIdApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<GetProdtDistributorInfoBySearchIdData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetProdtDistributorInfoBySearchIdResponses,
		GetProdtDistributorInfoBySearchIdErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/distributor/info/prodt/search-id/{searchId}',
		...options,
	});
};

export const getPublicTransportInfoApi = <ThrowOnError extends boolean = true>(
	options: Options<GetPublicTransportInfoData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetPublicTransportInfoResponses,
		GetPublicTransportInfoErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/distributor/info/public-transport/agency-name/{agencyName}',
		...options,
	});
};

export const getPublicTransportInfoByLegIdApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<GetPublicTransportInfoByLegIdData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetPublicTransportInfoByLegIdResponses,
		GetPublicTransportInfoByLegIdErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/distributor/info/public-transport/bookingleg-id/{bookingleg-id}',
		...options,
	});
};

export const getPublicTransportInfoByDistIdApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<GetPublicTransportInfoByDistIdData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetPublicTransportInfoByDistIdResponses,
		GetPublicTransportInfoByDistIdErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/distributor/info/public-transport/{distributor-id}',
		...options,
	});
};

export const getDriversApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetDriversData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetDriversResponses,
		GetDriversErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers',
		...options,
	});
};

export const getBookingLegsApi = <ThrowOnError extends boolean = true>(
	options: Options<GetBookingLegsData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		GetBookingLegsResponses,
		GetBookingLegsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/bookingLegs',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const checkInPassengerApi = <ThrowOnError extends boolean = true>(
	options: Options<CheckInPassengerData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CheckInPassengerResponses,
		CheckInPassengerErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/checkInPassenger',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getEmergencyCallApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetEmergencyCallData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetEmergencyCallResponses,
		GetEmergencyCallErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/emergencyCall',
		...options,
	});
};

export const activateEmergencyCallApi = <ThrowOnError extends boolean = true>(
	options?: Options<ActivateEmergencyCallData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		ActivateEmergencyCallResponses,
		ActivateEmergencyCallErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/emergencyCall/activate',
		...options,
	});
};

export const deactivateEmergencyCallApi = <ThrowOnError extends boolean = true>(
	options?: Options<DeactivateEmergencyCallData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		DeactivateEmergencyCallResponses,
		DeactivateEmergencyCallErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/emergencyCall/deactivate',
		...options,
	});
};

export const storeDriverLocationApi = <ThrowOnError extends boolean = true>(
	options: Options<StoreDriverLocationData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		StoreDriverLocationResponses,
		StoreDriverLocationErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/location',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getDriverMapsApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetDriverMapsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetDriverMapsResponses,
		GetDriverMapsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/map',
		...options,
	});
};

export const getCurrentScheduleApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetCurrentScheduleData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetCurrentScheduleResponses,
		GetCurrentScheduleErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/schedule',
		...options,
	});
};

export const toggleArchivation2Api = <ThrowOnError extends boolean = true>(
	options: Options<ToggleArchivation2Data, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		ToggleArchivation2Responses,
		ToggleArchivation2Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/toggleArchivation',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const checkInPassengerV2Api = <ThrowOnError extends boolean = true>(
	options: Options<CheckInPassengerV2Data, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CheckInPassengerV2Responses,
		CheckInPassengerV2Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/v2/checkInPassenger',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getDriverApi = <ThrowOnError extends boolean = true>(
	options: Options<GetDriverData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetDriverResponses,
		GetDriverErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/drivers/{driverid}',
		...options,
	});
};

export const getEmailStatusApi = <ThrowOnError extends boolean = true>(
	options: Options<GetEmailStatusData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetEmailStatusResponses,
		GetEmailStatusErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/emails/check',
		...options,
	});
};

export const getFeedbacksTableApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetFeedbacksTableData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetFeedbacksTableResponses,
		GetFeedbacksTableErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback',
		...options,
	});
};

export const getFeedbacksByBookingLegApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<GetFeedbacksByBookingLegData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetFeedbacksByBookingLegResponses,
		GetFeedbacksByBookingLegErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback/by-booking-leg/{bookingLegId}',
		...options,
	});
};

export const getFeedbacksByBookingApi = <ThrowOnError extends boolean = true>(
	options: Options<GetFeedbacksByBookingData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetFeedbacksByBookingResponses,
		GetFeedbacksByBookingErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback/by-booking/{bookingId}',
		...options,
	});
};

export const getFeedbacksByDriverApi = <ThrowOnError extends boolean = true>(
	options: Options<GetFeedbacksByDriverData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetFeedbacksByDriverResponses,
		GetFeedbacksByDriverErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback/by-driver/{driverId}',
		...options,
	});
};

export const getFeedbacksByUserApi = <ThrowOnError extends boolean = true>(
	options: Options<GetFeedbacksByUserData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetFeedbacksByUserResponses,
		GetFeedbacksByUserErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback/by-user/{userId}',
		...options,
	});
};

export const getDriverAndCarDetailsApi = <ThrowOnError extends boolean = true>(
	options: Options<GetDriverAndCarDetailsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetDriverAndCarDetailsResponses,
		GetDriverAndCarDetailsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/feedback/driver-car-details/{bookingLegId}',
		...options,
	});
};

export const getDriverLicenceFileApi = <ThrowOnError extends boolean = true>(
	options: Options<GetDriverLicenceFileData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetDriverLicenceFileResponses,
		GetDriverLicenceFileErrors,
		ThrowOnError
	>({
		responseType: 'blob',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/files/driver-licence/download/{fileuuid}',
		...options,
	});
};

export const handleDriverLicenceUploadApi = <
	ThrowOnError extends boolean = true
>(
	options?: Options<HandleDriverLicenceUploadData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		HandleDriverLicenceUploadResponses,
		HandleDriverLicenceUploadErrors,
		ThrowOnError
	>({
		...formDataBodySerializer,
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/files/driver-licence/upload',
		...options,
		headers: {
			'Content-Type': null,
			...options?.headers,
		},
	});
};

export const hereApiCallApi = <ThrowOnError extends boolean = true>(
	options: Options<HereApiCallData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		HereApiCallResponses,
		HereApiCallErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/here/autosuggest',
		...options,
	});
};

export const lookupApiCallApi = <ThrowOnError extends boolean = true>(
	options: Options<LookupApiCallData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		LookupApiCallResponses,
		LookupApiCallErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/here/lookup',
		...options,
	});
};

export const sendPushNotificationApi = <ThrowOnError extends boolean = true>(
	options: Options<SendPushNotificationData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		SendPushNotificationResponses,
		SendPushNotificationErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/notifications/send',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getAppleWalletPassApi = <ThrowOnError extends boolean = true>(
	options: Options<GetAppleWalletPassData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetAppleWalletPassResponses,
		GetAppleWalletPassErrors,
		ThrowOnError
	>({
		responseType: 'blob',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/appleWalletPass',
		...options,
	});
};

export const getBookingsApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetBookingsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetBookingsResponses,
		GetBookingsErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/bookings',
		...options,
	});
};

export const getDriverLocationApi = <ThrowOnError extends boolean = true>(
	options: Options<GetDriverLocationData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetDriverLocationResponses,
		GetDriverLocationErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/bookings/{uuid}/map',
		...options,
	});
};

export const canDeleteAccountApi = <ThrowOnError extends boolean = true>(
	options?: Options<CanDeleteAccountData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		CanDeleteAccountResponses,
		CanDeleteAccountErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/canDeleteAccount',
		...options,
	});
};

export const createPassengerApi = <ThrowOnError extends boolean = true>(
	options: Options<CreatePassengerData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CreatePassengerResponses,
		CreatePassengerErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/create',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

/**
 * Delete default payment method
 * Deletes the default payment method of the authenticated passenger.
 */
export const deleteDefaultPaymentMethodApi = <
	ThrowOnError extends boolean = true
>(
	options?: Options<DeleteDefaultPaymentMethodData, ThrowOnError>
) => {
	return (options?.client ?? client).delete<
		DeleteDefaultPaymentMethodResponses,
		DeleteDefaultPaymentMethodErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/defaultPaymentMethod',
		...options,
	});
};

export const getDefaultPaymentMethodApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetDefaultPaymentMethodData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetDefaultPaymentMethodResponses,
		GetDefaultPaymentMethodErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/defaultPaymentMethod',
		...options,
	});
};

/**
 * Set default payment method
 * Sets the default payment method of the authenticated passenger.
 */
export const setDefaultPaymentMethodApi = <ThrowOnError extends boolean = true>(
	options: Options<SetDefaultPaymentMethodData, ThrowOnError>
) => {
	return (options.client ?? client).put<
		SetDefaultPaymentMethodResponses,
		SetDefaultPaymentMethodErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/defaultPaymentMethod',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

/**
 * Check if default payment method can be deleted
 * Returns whether the authenticated passenger can currently delete the default payment method.
 */
export const canDeleteDefaultPaymentMethodApi = <
	ThrowOnError extends boolean = true
>(
	options?: Options<CanDeleteDefaultPaymentMethodData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		CanDeleteDefaultPaymentMethodResponses,
		CanDeleteDefaultPaymentMethodErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/defaultPaymentMethod/canDelete',
		...options,
	});
};

export const deletePassengerApi = <ThrowOnError extends boolean = true>(
	options?: Options<DeletePassengerData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		DeletePassengerResponses,
		DeletePassengerErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/delete',
		...options,
	});
};

export const deleteTokenApi = <ThrowOnError extends boolean = true>(
	options?: Options<DeleteTokenData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		DeleteTokenResponses,
		DeleteTokenErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/deleteTokens',
		...options,
	});
};

/**
 * Update passenger details
 * Updates the personal and address details for the authenticated user and performs fraud detection checks.
 */
export const addPassengerDetailsApi = <ThrowOnError extends boolean = true>(
	options: Options<AddPassengerDetailsData, ThrowOnError>
) => {
	return (options.client ?? client).put<
		AddPassengerDetailsResponses,
		AddPassengerDetailsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/details',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getDigitalBonusApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetDigitalBonusData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetDigitalBonusResponses,
		GetDigitalBonusErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/digitalBonus',
		...options,
	});
};

export const giveFeedbackForJourneyApi = <ThrowOnError extends boolean = true>(
	options: Options<GiveFeedbackForJourneyData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		GiveFeedbackForJourneyResponses,
		GiveFeedbackForJourneyErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/feedbackJourney',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetData, ThrowOnError>
) => {
	return (options?.client ?? client).get<GetResponses, GetErrors, ThrowOnError>(
		{
			responseType: 'json',
			security: [
				{
					scheme: 'bearer',
					type: 'http',
				},
			],
			url: '/api/passengers/germanyTicketSubscriptionOffering',
			...options,
		}
	);
};

export const getGoogleWalletApi = <ThrowOnError extends boolean = true>(
	options: Options<GetGoogleWalletData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetGoogleWalletResponses,
		GetGoogleWalletErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/googleWallet',
		...options,
	});
};

export const hasVoucherRemeededApi = <ThrowOnError extends boolean = true>(
	options?: Options<HasVoucherRemeededData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		HasVoucherRemeededResponses,
		HasVoucherRemeededErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/hasVoucherRedeemed',
		...options,
	});
};

export const getNewIntentApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetNewIntentData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetNewIntentResponses,
		GetNewIntentErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/intent',
		...options,
	});
};

export const getAvailableInvoicesApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetAvailableInvoicesData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetAvailableInvoicesResponses,
		GetAvailableInvoicesErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/invoices',
		...options,
	});
};

export const sendInvoiceEmailForGermanyTicketApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<SendInvoiceEmailForGermanyTicketData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		SendInvoiceEmailForGermanyTicketResponses,
		SendInvoiceEmailForGermanyTicketErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/invoices',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

/**
 * Set alternate invoice address
 * Sets an alternate invoice address for the authenticated passenger.
 */
export const setAlternateInvoiceAddressApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<SetAlternateInvoiceAddressData, ThrowOnError>
) => {
	return (options.client ?? client).put<
		SetAlternateInvoiceAddressResponses,
		SetAlternateInvoiceAddressErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/invoices/address',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const sendInvoiceEmailForBookingApi = <
	ThrowOnError extends boolean = true
>(
	options: Options<SendInvoiceEmailForBookingData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		SendInvoiceEmailForBookingResponses,
		SendInvoiceEmailForBookingErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/invoices/booking',
		...options,
	});
};

export const removeBookingApi = <ThrowOnError extends boolean = true>(
	options: Options<RemoveBookingData, ThrowOnError>
) => {
	return (options.client ?? client).delete<
		RemoveBookingResponses,
		RemoveBookingErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/removeBooking',
		...options,
	});
};

export const createSubscriptionApi = <ThrowOnError extends boolean = true>(
	options: Options<CreateSubscriptionData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CreateSubscriptionResponses,
		CreateSubscriptionErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/subscription/create',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const cancelCancellationApi = <ThrowOnError extends boolean = true>(
	options: Options<CancelCancellationData, ThrowOnError>
) => {
	return (options.client ?? client).delete<
		CancelCancellationResponses,
		CancelCancellationErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/subscription/{subscriptionId}/cancellation',
		...options,
	});
};

export const getSubscriptionsApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetSubscriptionsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetSubscriptionsResponses,
		GetSubscriptionsErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/subscriptions',
		...options,
	});
};

export const getSyncBookingsApi = <ThrowOnError extends boolean = true>(
	options: Options<GetSyncBookingsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetSyncBookingsResponses,
		GetSyncBookingsErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/syncBookings',
		...options,
	});
};

export const getTicketsApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetTicketsData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetTicketsResponses,
		GetTicketsErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/tickets',
		...options,
	});
};

export const regenerateTicketApi = <ThrowOnError extends boolean = true>(
	options: Options<RegenerateTicketData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		RegenerateTicketResponses,
		RegenerateTicketErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/passengers/tickets/regenerate/{userId}',
		...options,
	});
};

export const calculatePriceApi = <ThrowOnError extends boolean = true>(
	options: Options<CalculatePriceData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CalculatePriceResponses,
		CalculatePriceErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/pricing/calculate',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

/**
 * @deprecated
 */
export const postCapacityCheckApi = <ThrowOnError extends boolean = true>(
	options: Options<PostCapacityCheckData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		PostCapacityCheckResponses,
		PostCapacityCheckErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/lbodtflex/capacitycheck',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const deleteCapacityCheckApi = <ThrowOnError extends boolean = true>(
	options: Options<DeleteCapacityCheckData, ThrowOnError>
) => {
	return (options.client ?? client).delete<
		DeleteCapacityCheckResponses,
		DeleteCapacityCheckErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}',
		...options,
	});
};

/**
 * @deprecated
 */
export const getCapacityCheckApi = <ThrowOnError extends boolean = true>(
	options: Options<GetCapacityCheckData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetCapacityCheckResponses,
		GetCapacityCheckErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}',
		...options,
	});
};

export const patchCapacityCheck1Api = <ThrowOnError extends boolean = true>(
	options: Options<PatchCapacityCheck1Data, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		PatchCapacityCheck1Responses,
		PatchCapacityCheck1Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/lbodtflex/capacitycheck/{capacityCheckId}',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getPlanApi = <ThrowOnError extends boolean = true>(
	options: Options<GetPlanData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetPlanResponses,
		GetPlanErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/plan',
		...options,
	});
};

export const getCheaperTripsApi = <ThrowOnError extends boolean = true>(
	options: Options<GetCheaperTripsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetCheaperTripsResponses,
		GetCheaperTripsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/plan/cheaperTrips',
		...options,
	});
};

export const postSearchApi = <ThrowOnError extends boolean = true>(
	options: Options<PostSearchData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		PostSearchResponses,
		PostSearchErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/prodt/search',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const deleteSearchApi = <ThrowOnError extends boolean = true>(
	options: Options<DeleteSearchData, ThrowOnError>
) => {
	return (options.client ?? client).delete<
		DeleteSearchResponses,
		DeleteSearchErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/prodt/search/{searchId}',
		...options,
	});
};

export const getSearchApi = <ThrowOnError extends boolean = true>(
	options: Options<GetSearchData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetSearchResponses,
		GetSearchErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/prodt/search/{searchId}',
		...options,
	});
};

export const patchSearch1Api = <ThrowOnError extends boolean = true>(
	options: Options<PatchSearch1Data, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		PatchSearch1Responses,
		PatchSearch1Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/router/prodt/search/{searchId}',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const runSchedulerApi = <ThrowOnError extends boolean = true>(
	options: Options<RunSchedulerData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		RunSchedulerResponses,
		RunSchedulerErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/run-scheduler',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const runSchedulersNearFutureApi = <ThrowOnError extends boolean = true>(
	options?: Options<RunSchedulersNearFutureData, ThrowOnError>
) => {
	return (options?.client ?? client).post<
		RunSchedulersNearFutureResponses,
		RunSchedulersNearFutureErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/run-scheduler/all',
		...options,
	});
};

export const getScheduleApi = <ThrowOnError extends boolean = true>(
	options: Options<GetScheduleData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetScheduleResponses,
		GetScheduleErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/run-scheduler/{schedulerId}',
		...options,
	});
};

export const getAccountsApi = <ThrowOnError extends boolean = true>(
	options: Options<GetAccountsData, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetAccountsResponses,
		GetAccountsErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/truelayer/accounts',
		...options,
	});
};

export const createSepaPaymentMethodApi = <ThrowOnError extends boolean = true>(
	options: Options<CreateSepaPaymentMethodData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CreateSepaPaymentMethodResponses,
		CreateSepaPaymentMethodErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/truelayer/createSepaPaymentMethod',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const changeEmailAddressApi = <ThrowOnError extends boolean = true>(
	options: Options<ChangeEmailAddressData, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		ChangeEmailAddressResponses,
		ChangeEmailAddressErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/email',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const validateEmailAddressApi = <ThrowOnError extends boolean = true>(
	options: Options<ValidateEmailAddressData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		ValidateEmailAddressResponses,
		ValidateEmailAddressErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/email/validate',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const setLanguageApi = <ThrowOnError extends boolean = true>(
	options: Options<SetLanguageData, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		SetLanguageResponses,
		SetLanguageErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/language',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const spenditTokenApi = <ThrowOnError extends boolean = true>(
	options: Options<SpenditTokenData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		SpenditTokenResponses,
		SpenditTokenErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/spenditToken',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const removeVoucherApi = <ThrowOnError extends boolean = true>(
	options: Options<RemoveVoucherData, ThrowOnError>
) => {
	return (options.client ?? client).delete<
		RemoveVoucherResponses,
		RemoveVoucherErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/vouchers',
		...options,
	});
};

export const redeemVoucherApi = <ThrowOnError extends boolean = true>(
	options: Options<RedeemVoucherData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		RedeemVoucherResponses,
		RedeemVoucherErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/vouchers',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getActiveVouchersApi = <ThrowOnError extends boolean = true>(
	options?: Options<GetActiveVouchersData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		GetActiveVouchersResponses,
		GetActiveVouchersErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/vouchers/active',
		...options,
	});
};

export const validateVoucherApi = <ThrowOnError extends boolean = true>(
	options: Options<ValidateVoucherData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		ValidateVoucherResponses,
		ValidateVoucherErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/users/vouchers/validate',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getFeatureFlagV2Api = <ThrowOnError extends boolean = true>(
	options: Options<GetFeatureFlagV2Data, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetFeatureFlagV2Responses,
		GetFeatureFlagV2Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v2/feature-flags/{flag}',
		...options,
	});
};

export const postCapacityCheckV2Api = <ThrowOnError extends boolean = true>(
	options: Options<PostCapacityCheckV2Data, ThrowOnError>
) => {
	return (options.client ?? client).post<
		PostCapacityCheckV2Responses,
		PostCapacityCheckV2Errors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v2/router/lbodtflex/capacitycheck',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const getCapacityCheckV2Api = <ThrowOnError extends boolean = true>(
	options: Options<GetCapacityCheckV2Data, ThrowOnError>
) => {
	return (options.client ?? client).get<
		GetCapacityCheckV2Responses,
		GetCapacityCheckV2Errors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v2/router/lbodtflex/capacitycheck/{capacityCheckId}',
		...options,
	});
};

export const patchCapacityCheckApi = <ThrowOnError extends boolean = true>(
	options: Options<PatchCapacityCheckData, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		PatchCapacityCheckResponses,
		PatchCapacityCheckErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v2/router/lbodtflex/capacitycheck/{capacityCheckId}',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const patchSearchApi = <ThrowOnError extends boolean = true>(
	options: Options<PatchSearchData, ThrowOnError>
) => {
	return (options.client ?? client).patch<
		PatchSearchResponses,
		PatchSearchErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/v2/router/prodt/search/{searchId}',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const checkVehicleApi = <ThrowOnError extends boolean = true>(
	options: Options<CheckVehicleData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		CheckVehicleResponses,
		CheckVehicleErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/vehicleCheck',
		...options,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
	});
};

export const startVehicleCheckApi = <ThrowOnError extends boolean = true>(
	options: Options<StartVehicleCheckData, ThrowOnError>
) => {
	return (options.client ?? client).post<
		StartVehicleCheckResponses,
		StartVehicleCheckErrors,
		ThrowOnError
	>({
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/vehicleCheck/{assignmentId}/start',
		...options,
	});
};

export const whoAmIApi = <ThrowOnError extends boolean = true>(
	options?: Options<WhoAmIData, ThrowOnError>
) => {
	return (options?.client ?? client).get<
		WhoAmIResponses,
		WhoAmIErrors,
		ThrowOnError
	>({
		responseType: 'json',
		security: [
			{
				scheme: 'bearer',
				type: 'http',
			},
		],
		url: '/api/whoami',
		...options,
	});
};
